<template>
  <div class="option-card" v-if="item">
    <!-- Top Block: Background with Image -->
    <div class="option-card-top">
      <div class="option-image-wrapper">
        <img
          :src="imgDomain + item.image_url"
          :alt="item.title"
          class="option-image"
        />
      </div>
    </div>
    <!-- Bottom Block: Title and Price -->
    <div class="option-card-bottom">
      <h4 class="option-title" :title="$t(item.title)">{{ $t(item.title) }}</h4>
      <p class="option-price">
        <span>{{ item.price }}</span>
        <img src="@/assets/coin.svg" alt="coin" class="coin" />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "OptionCard",
  props: ["item", "currency"],
  data: function () {
    return {
      imgDomain: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
};
</script>

<style lang="scss">
.option-card {
  width: 345px;
  border-radius: 30px;
  background: #ffffffcc;
  display: flex;
  flex-direction: column;
  border: 1px solid #ffffff;
}

.option-card-top {
  padding: 30px 16px 25px;
  width: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  display: flex;
  align-items: center;
  justify-content: center;
}

.option-image-wrapper {
  width: 140px;
  height: 140px;
}

.option-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Bottom Block with Title and Price */
.option-card-bottom {
  padding: 0 30px 26px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.option-title {
  font-family: "Inter", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60%;
  color: #0b2535;
}

.option-price {
  font-family: "Inter", sans-serif;
  font-size: 28px;
  font-weight: 900;
  line-height: 28px;
  text-align: right;
  color: #0b2535;
  display: flex;
  align-content: center;
  gap: 4px;

  .coin {
    width: 24px;
  }
}
</style>
